import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBackOfficeListSubscriptionPackages: build.query<
      GetBackOfficeListSubscriptionPackagesApiResponse,
      GetBackOfficeListSubscriptionPackagesApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/subscription-packages`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          keyword: queryArg.keyword,
          sort: queryArg.sort,
        },
      }),
    }),
    updateSubscriptionPackageById: build.mutation<
      UpdateSubscriptionPackageByIdApiResponse,
      UpdateSubscriptionPackageByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/subscription-packages/${queryArg.id}`,
        method: "PUT",
        body: queryArg.subscriptionPackageUpdateRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type GetBackOfficeListSubscriptionPackagesApiResponse =
  /** status 200 OK */ BackOfficeSubscriptionPackagePage;
export type GetBackOfficeListSubscriptionPackagesApiArg = {
  /** page */
  page?: number;
  /** size */
  size?: number;
  /** keyword to search */
  keyword?: string;
  /** Format is sort=distance:desc,name:asc. Supported keys: createdAt, updatedAt, name, duration, credits */
  sort?: string[];
};
export type UpdateSubscriptionPackageByIdApiResponse =
  /** status 200 OK */ SuccessResponse200;
export type UpdateSubscriptionPackageByIdApiArg = {
  /** uuid */
  id: string;
  /** Subscription package update */
  subscriptionPackageUpdateRequest: SubscriptionPackageUpdateRequest;
};
export type EntityProductType = "pt-subscription" | "pt-credits";
export type EntityProduct = {
  createdAt?: string;
  description?: string;
  /** Product id of Google Play Store */
  googleVendorProductID?: string;
  id?: string;
  priceLevel?: number;
  /** The product can be a subscription or a one-time credit purchase. */
  type?: EntityProductType;
  updatedAt?: string;
  /** Product id of Apple App Store */
  vendorProductID?: string;
};
export type EntitySubscriptionPackage = {
  createdAt?: string;
  /** Credits included in the subscription package */
  credits?: number;
  description?: string;
  /** Duration in days/months, only informative, true duration is defined by the plan on Apple/Google */
  duration?: number;
  id?: string;
  name?: string;
  plan?: "sp-basic" | "sp-premium";
  product?: EntityProduct;
  status?: "sps-active" | "sps-inactive";
  updatedAt?: string;
};
export type BackOfficeSubscriptionPackagePage = {
  count?: number;
  items?: EntitySubscriptionPackage[];
  last?: boolean;
  page?: number;
  size?: number;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ErrorResponse404 = {
  code?: number;
  data?: {
    [key: string]: string;
  }[];
  message?: string;
};
export type SuccessResponse200 = {
  status?: string;
};
export type SubscriptionPackageUpdateRequest = {
  credits?: number;
  description?: string;
  duration?: number;
  name?: string;
  plan?: "sp-basic" | "sp-premium";
  productId?: number;
  status?: "sps-active" | "sps-inactive";
};
export const {
  useGetBackOfficeListSubscriptionPackagesQuery,
  useUpdateSubscriptionPackageByIdMutation,
} = injectedRtkApi;
